/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs */

const en_guide_json_vs_yaml_xml_faq_a1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Valid JSON is also valid YAML (in YAML 1.2). This means you can use a YAML parser to read JSON files, but not the other way around.`)
};

const ko_guide_json_vs_yaml_xml_faq_a1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 유효한 JSON은 유효한 YAML이기도 합니다(YAML 1.2 기준). 즉, YAML 파서로 JSON 파일을 읽을 수 있지만, 그 반대는 불가능합니다.`)
};

const ja_guide_json_vs_yaml_xml_faq_a1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。有効なJSONは有効なYAML（YAML 1.2）でもあります。つまり、YAMLパーサーでJSONファイルを読むことができますが、その逆はできません。`)
};

/**
* | output |
* | --- |
* | "Yes. Valid JSON is also valid YAML (in YAML 1.2). This means you can use a YAML parser to read JSON files, but not the other way around." |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_a1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_a1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_a1(inputs)
	return ja_guide_json_vs_yaml_xml_faq_a1(inputs)
});